import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.div`
  --width: 350px;
  --height: 325px;
  --border-radius: 24px;

  & {
    color: ${({ theme }) => theme.colors.gray[900]};
    border: none;
    width: var(--width);
    min-height: var(--height);
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
    // cursor: pointer;
    position: relative;
  }

  & > figure {
    overflow: visible;
    position: absolute;
    left: 1px;
    top: 1px;
    right: 1px;
    bottom: 1px;
    z-index: 0;
  }

  & > article {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    padding: 3%;
    background-color: ${({ theme }) => theme.colors.gray[0]};
    border-radius: var(--border-radius);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column nowrap;
  }

  .widget-background {
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.primary[400]};
    border-radius: var(--border-radius);
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '--width': ['290px', '290px', '320px', '350px'],
        '--height': ['265px', '265px', '297px', '325px'],
      }),
    ).styles}}
`

export default Container
